import { Angle, Keyword, Number, Rotate, Token } from "@siteimprove/alfa-css";
import { Parser } from "@siteimprove/alfa-parser";
import { Err, Ok } from "@siteimprove/alfa-result";
import { Longhand } from "../longhand.js";
const { either, left, map, mapResult, option, pair, separatedList } = Parser;
function takeThree(array) {
    return array.length === 3
        ? Ok.of(array)
        : Err.of("Wrong number of coordinates in rotate axis");
}
// We cannot reuse Rotate.parse which includes the rotation function.
// We'll probably need to refactor these a bit, together with adding translate
// and scale properties.
const parseAxis = either(Keyword.parse("x"), Keyword.parse("y"), Keyword.parse("z"), 
// We need to not consume the last whitespace which is expected by parseRotate,
// so we can hardly use Parser.take.
mapResult(separatedList(Number.parse, Token.parseWhitespace), takeThree));
/**
 * {@link https://en.wikipedia.org/wiki/Kronecker_delta}
 */
function delta(keyword, data) {
    return keyword.value === data ? 1 : 0;
}
const parseRotate = map(pair(option(left(parseAxis, Token.parseWhitespace)), Angle.parse), ([axis, angle]) => {
    for (const value of axis) {
        if (Keyword.isKeyword(value)) {
            return Rotate.of(Number.of(delta(value, "x")), Number.of(delta(value, "y")), Number.of(delta(value, "z")), angle);
        }
        return Rotate.of(value[0], value[1], value[2], angle);
    }
    // No axis was provided, default is to rotate around z axis.
    return Rotate.of(Number.of(0), Number.of(0), Number.of(1), angle);
});
const parse = either(Keyword.parse("none"), parseRotate);
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/rotate}
 * @internal
 */
export default Longhand.of(Keyword.of("none"), parse, (rotate) => rotate);
//# sourceMappingURL=rotate.js.map